// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.healthcare-service-details-layout {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.healthcare-service-details-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.healthcare-service-details-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem;
}

.healthcare-service-detail-card {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 1rem 1rem 0.95rem;
  border-radius: 0.85rem;
  background: rgba(0, 0, 0, 0.02);
  border: 0.0625rem solid rgba(0, 0, 0, 0.06);
}

.healthcare-service-detail-card-full {
  grid-column: 1 / -1;
}

.healthcare-service-detail-label {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--secondary-color);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.healthcare-service-detail-value {
  color: var(--secondary-color);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.healthcare-service-location-list {
  min-height: 2.5rem;
}

@media screen and (max-width: 991px) {
  .healthcare-service-details-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/HealthcareServiceDetails/HealthcareServiceDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,0BAA0B;EAC1B,sBAAsB;EACtB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".healthcare-service-details-layout {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.healthcare-service-details-badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.healthcare-service-details-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.9rem;\n}\n\n.healthcare-service-detail-card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 1rem 1rem 0.95rem;\n  border-radius: 0.85rem;\n  background: rgba(0, 0, 0, 0.02);\n  border: 0.0625rem solid rgba(0, 0, 0, 0.06);\n}\n\n.healthcare-service-detail-card-full {\n  grid-column: 1 / -1;\n}\n\n.healthcare-service-detail-label {\n  font-size: 0.85rem;\n  font-weight: 700;\n  color: var(--secondary-color);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.healthcare-service-detail-value {\n  color: var(--secondary-color);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.healthcare-service-location-list {\n  min-height: 2.5rem;\n}\n\n@media screen and (max-width: 991px) {\n  .healthcare-service-details-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
